<template>
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">非配额订单下单</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <!-- 页面详情状态 -->
        <form-button v-if="pageMode == 'edit'" @click="$router.go(-1)">返回</form-button>
        <!-- 页面新建状态 -->
        <template v-if="$_has(['WLY001', 'WLY002', 'WLYALL']) && !conditions.OBJECT_ID">
          <form-button type="primary" @click="changeStatus('SAVE')">保存</form-button>
        </template>
        <template v-if="conditions.OBJECT_ID">
          <template v-if="conditions.STATUS === 'E0004'">
            <template v-if="conditions.change">
              <form-button v-if="!showEdit" @click="orderModify">修改</form-button>
            </template>
            <template v-if="conditions.follow_up && !showEdit">
              <form-button @click="showNext = true">创建后续</form-button>
            </template>
          </template>

          <template v-else-if="conditions.STATUS === 'E0003'">
            <form-button v-if="!showEdit && $_has(['WLY002', 'WLYALL'])" @click="orderModify">修改</form-button>
          </template>

          <template v-else-if="conditions.STATUS !== 'E0006' && !showEdit && $_has(['WLY001', 'WLY002', 'WLYALL'])">
            <form-button @click="orderModify">修改</form-button>
          </template>
          <template v-if="conditions.STATUS !== 'E0006' && !showEdit && $_has(['WLY002', 'WLY006', 'WLYALL'])">
            <form-button @click="orderlock('UNLOCK')">订单解锁</form-button>
          </template>
        </template>

        <!-- 修改状态 -->
        <template v-if="showEdit">
          <form-button @click="orderDisplay">显示</form-button>
          <template v-if="conditions.STATUS === 'E0002' || conditions.STATUS === 'E0005'">
            <form-button v-if="$_has(['WLY001', 'WLY002','WLYALL'])" type="primary" @click="changeStatus('SAVE')">保存</form-button>
            <form-button v-if="$_has(['WLY002','WLYALL'])" icon="form-advance" @click="changeStatus('SUBMIT')">提交</form-button>
            <form-button v-if="$_has(['WLY001', 'WLY002','WLYALL'])" @click="changeStatus('CANCEL')">取消</form-button>
          </template>

          <template v-if="conditions.STATUS === 'E0003'">
            <form-button @click="changeStatus('APPROVE')">审核通过</form-button>
            <form-button @click="changeStatus('REJECT')">审核拒绝</form-button>
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>

          <template v-if="conditions.STATUS === 'E0004' && conditions.cancel">
            <form-button @click="changeStatus('CANCEL')">取消</form-button>
          </template>
        </template>
      </div>
      <el-form
        ref="form"
        :show-message="false"
        inline
        size="mini"
        label-width="100px"
        :model="conditions"
        :rules="rules"
        :disabled="isEdit"
      >
        <common-title title="抬头明细" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="订单编号">
              <el-input
                :value="conditions.OBJECT_ID"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="订单类型">
              <el-select
                :value="conditions.PROCESS_TYPE"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0043']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                :value="conditions.CUST_NAME"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="CUSTOMER" label="客户编号">
              <wly-input
                v-model="conditions.CUSTOMER"
                input-type="customer"
                :disabled="role.ROLE === 'WLY001'"
                @enter="handleEnter"
                @handleSuffixClick="openSelectDialog($event, 'client')"
              />
              <!-- <el-input
                v-model="conditions.CUSTOMER"
                placeholder="请输入"
                @focus="openSelectDialog($event, 'client')"
              /> -->
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select :value="conditions.CUSTOMER_TYPE" placeholder="" clearable disabled>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

           <el-col :lg="8" :md="12">
            <el-form-item label="定制名称">
              <el-input v-model="conditions.ZCUSTOM_NAME" placeholder="" clearable :disabled="isEdit" />
            </el-form-item>
          </el-col>

          <!-- <el-col :lg="8" :md="12">
            <el-form-item label="货款余额">
              <el-input v-model="conditions.ZHKYE" disabled placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="随量保证金">
              <el-input v-model="conditions.slbzj" disabled placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="固定保证金">
              <el-input v-model="conditions.gdbzj" disabled placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票要求">
              <el-input v-model="conditions.kpyq" disabled placeholder="请输入" clearable />
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.ZZFLD000028"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.ZZFLD00000"
                :disabled="conditions.STATUS !== 'E0003'"
                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                :value="conditions.ZZFLD00002D_DSCR"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                :value="conditions.POSTING_DATE"
                placeholder="请输入"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-select
                :value="conditions.STATUS"
                placeholder=""
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['A0041']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="ZZFLD000001">
              <el-select
                v-model="conditions.ZZFLD000001"
                placeholder=""
                type="select"
                :disabled="!selectDataOptions.orgList || selectDataOptions.orgList.length == 1"
                @change="saleCenterChange"
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input
                :value="conditions.ZZFLD00003E"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省份">
              <el-input
                :value="conditions.ZZFLD000002_TEXT"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input
                :value="conditions.ZZFLD000003_TEXT"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input
                :value="conditions.ZZFLD000004_DSCR"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="运达方" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="ZZFLD00008T" label="收货方编码">
              <el-input
                v-model="conditions.ZZFLD00008T"
                type="text"
                @focus="openSelectDialog($event, 'receive')"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货方名称">
              <el-input
                :value="conditions.ZZFLD00008T_DSCR"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系人">
              <el-input
                :value="conditions.ZZFLD00002L"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系电话">
              <el-input
                :value="conditions.ZZFLD00002M"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货地址">
              <el-input :value="conditions.ZZFLD00002N" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <div class="form-btns">
          <el-button
            type="primary"
            size="mini"
            @click="openSelectDialog($event, 'clientAdd', {}, 'client')"
          >新增客户</el-button>
          <el-button
            type="primary"
            size="mini"
            @click="openSelectDialog($event, 'clientAdd', {}, 'address')"
          >新增地址</el-button>
        </div>
      </el-form>
    </div>
    
    <div class="table-container">
      <TableCommon title="销售订单行项目" :custome-config="() => vxeShowCustom('orderDetail')">
        <template #button v-if="conditions.STATUS === 'E0001' || conditions.STATUS === 'E0002'">
          <table-button name="save" :disabled="isEdit" tip="保存" @click="updateSaleItem" />
          <table-button name="add" :disabled="isEdit" tip="增加" @click="tableEvent('add')" />
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="tableEvent('del')" />
        </template>
        <vxe-grid
          ref="orderDetail"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.orderDetailcolumns"
          :data="gridOptions.orderData"
        >
          <template #ORDERED_PROD="{row}">
            <wly-input
              v-model="row.ORDERED_PROD"
              size="mini"
              :disabled="isEdit"
              input-type="salesProduct"
              :sales-query-params="productParams"
              @enter="handleEnter(...arguments, row)"
              @handleSuffixClick="openSelectDialog($event, 'product', row)"
            />
          </template>
          <template #REWARD_TYPE="{row,rowIndex}">
            <el-select
              v-model="row.REWARD_TYPE"
              size="mini"
              placeholder=""
              clearable
              @change='changeType($event,rowIndex)'
            >
              <el-option
                v-for="item2 in selectDataOptions['A0077']"
                :key="item2.value"
                :label="item2.name"
                :value="item2.value"
              />
            </el-select>
          </template>
          <template #REWARD_NUMBER="{row}">
            <el-input
              v-model="row.REWARD_NUMBER"
              :disabled="isEdit || !row.REWARD_TYPE"
              size="mini"
              @focus="openSelectDialog($event, 'reward', row)"
            />
          </template>
          <template #ZZFLD000009="{row}">
            <el-input
              v-model.number="row.ZZFLD000009"
              :disabled="isEdit"
              size="mini"
              @keyup.enter.native="updateSaleItem"
            />
          </template>
          <template #ZZFLD00002X="{row}">
            <el-input
              v-model="row.ZZFLD00002X"
              size="mini"
              :disabled="isEdit? isEdit : conditions.ZZFLD000001 != (isDeve?'0005000273': '0005000310')"
              @keyup.enter.native="updateSaleItem"
            />
          </template>
          <template #ZZFLD000008="{row}">
            <el-input
              v-model="row.ZZFLD000008"
              :disabled="isEdit"
              size="mini"
            />
          </template>
          <template #ZZFLD00002A="{row}">
            <el-select
              v-model="row.ZZFLD00002A"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : isEdit"
              size="mini"
              placeholder=""
            >
              <el-option
                v-for="item in selectDataOptions['A0037']"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              />
            </el-select>
          </template>
          <template #ZZFLD00002I="{row}">
            <el-input
              v-model="row.ZZFLD00002I"
              :disabled="(role.ROLE !== 'WLY002' && role.ROLE !== 'WLYALL') ? true : isEdit"
              size="mini"
              type="number"
              @keyup.enter.native="updateSaleItem"
            />
          </template>
          <template #ZZFLD00002B="{row}">
            <el-checkbox
              v-model="row.ZZFLD00002B"
              true-label="X"
              false-label=""
              disabled
            >是</el-checkbox>
          </template>
        </vxe-grid>
      </TableCommon>
      
      <TableCommon title="剩余现金奖励" :custome-config="() => vxeShowCustom('fileTable')" v-if="role.ROLE == 'WLY002' || role.ROLE == 'WLYALL'">
        <template #button>
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsCash.columns"
          :data="gridOptionsCash.data"
        >
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" :disabled="isEdit" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" :disabled="isEdit" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.fileDetailColumns"
          :data="gridOptions.fileData"
        >
          <template #FILENAME="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.FILENAME }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('xTable3')">
        <vxe-grid
          ref="xTable3"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>

      <TableCommon title="关联单据" :custome-config="() => vxeShowCustom('gridOptionsLinkBill')">
        <vxe-grid
          ref="gridOptionsLinkBill"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsLinkBill.columns"
          :data="gridOptionsLinkBill.data"
        />
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <cashRewards v-if="showDialogType === 'reward'" :head='conditions' :item=currentDetail :allData="gridOptions.orderData" ref="dialogEdit"/>
        <client-add
          v-if="showDialogType === 'clientAdd'"
          ref="dialogEdit"
          :mode="mode"
          :init-data="initClientAddData"
        />
        <client-select v-if="showDialogType === 'client'" ref="dialogEdit" />
        <client-group-arrival-select
          v-if="showDialogType === 'receive'"
          ref="dialogEdit"
          :info="conditions"
          mode="NO_QUOTA"
        />
        <sale-product-select
          v-if="showDialogType === 'product'"
          ref="dialogEdit"
          :info="productParams"
        />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag :visible.sync="showNext" title="后续单据选择">
      <vxe-grid
        ref="next"
        class="table-block"
        border
        :highlight-hover-row="true"
        resizable
        :show-overflow="true"
        align="center"
        size="mini"
        :empty-render="{ name: 'NotData' }"
        :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
        :edit-config="{ trigger: 'manual', mode: 'row' }"
        :columns="gridOptionsNext.columns"
        :data="gridOptionsNext.data"
      />
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showNext = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="createNext"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { formatSapTime, formatSapDate, formatSapFileSize } from '@/mixins/index'
import { sapDownloadFile } from '@/utils/frontExport'
import { apiInitClientAdd, apiClientAdd } from '@/api/client'
import { apiNoQuotaUpdateSaleItem, apiNoQuotaSave, getOrderDetail, apiCreateFollow } from '@/api/sap/order-sap'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiSapSingleClientInfo, apiOrderLock } from '@/api/common'
const cashRewards = () => import('@/views/reward-policy/components/cashRewards.vue')
const SaleProductSelect = () => import('@/components/dialog/SaleProductSelect')
const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const ClientGroupArrivalSelect = () => import('@/components/dialog/ClientGroupArrivalSelect.vue')
const ClientAdd = () => import('@/components/dialog/ClientAdd.vue')

import { mapGetters } from 'vuex'

export default {
  components: {
    SaleProductSelect,
    ClientSelect,
    ClientGroupArrivalSelect,
    ClientAdd,
    cashRewards
  },
  data() {
    const rules = {
      CUSTOMER: [{ required: true, message: '请选择客户', trigger: 'change' }],
      ZZFLD000001: [{ required: true, message: '请选择营销单元', trigger: 'change' }]
      // ZZFLD00008T: [{ required: true, message: '请选择收货单位', trigger: 'change' }]
    }
    return {
      rules,
      mdoe: 'client',
      validRules: {
        ORDERED_PROD: [{ required: true }],
        ZZFLD000009: [{ required: true }]
      },
      showNext: false,
      pageMode: 'add',
      showEdit: false,
      errorList: [],
      conditions: {
        OBJECT_ID: '', // 订单编号
        PROCESS_TYPE: 'ZS02', // 订单类型
        CUSTOMER: '', // 客户编码
        CUST_NAME: '', // 客户名称
        CUSTOMER_TYPE: '', // 客户类型
        ZZFLD00000: '', // 审核意见
        ZZFLD000028: '', // 备注
        ZZFLD00002D: '', // 创建人编号
        ZZFLD00002D_DSCR: '', // 创建人描述
        POSTING_DATE: '', // 创建时间
        STATUS: 'E0001', // 状态
        ZZFLD000001: '', // 营销单元
        ZZFLD000001Name: '',
        ZZFLD00003E: '', // 基地
        ZZFLD000002: '', // 省区
        ZZFLD000003: '', // 城市
        ZZFLD000004: '', // 业务员
        ZZFLD000004_DSCR: '', // 业务员描述
        ZZFLD00002J: '', // 客户性质
        ZZFLD00002K: '', // 发货类型
        ZZFLD00002L: '', // 收货联系人
        ZZFLD00002M: '', // 收货联系电话
        ZZFLD00008T: '', // 收货方
        ZZFLD00008T_DSCR: '', // 收货方
        ZHKYE: '', // 货款余额
        slbzj: '',
        gdbzj: '',
        kpyq: '',
        ZZFLD00003C: 'WEB'
      },
      initClientAddData: {},
      dialogTitle: '',
      showDialog: false,
      showDialogType: '',
      productParams: {
        PROCESS_TYPE: 'ZS02',
        CUSTOMER: '',
        mode: 'NO_QUOTA'
      },
      currentDetail: {},
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        orderDetailcolumns: [
          { field: 'checkbox', type: 'checkbox', title: '', width: 40 },
          {
            field: 'NUMBER_INT',
            title: '行号',
            width: 50,
            formatter: ({ cellValue }) => Number(cellValue)
          },
          {
            field: 'ORDERED_PROD',
            title: '产品编码',
            width: 140,
            slots: { default: 'ORDERED_PROD' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'DESCRIPTION',
            title: '产品描述',
            width: 180
          },
          {
            field: 'ZZFLD00002S',
            title: '规格型号',
            width: 100
          },
          {
            field: 'ZZFLD00002T',
            title: '单位',
            width: 80
          },
          {
            field: 'ZZFLD00002U',
            title: '数量',
            width: 80
          },
          {
            field: 'ZZFLD000009',
            title: '件数',
            width: 80,
            slots: { default: 'ZZFLD000009' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002E',
            title: '税率',
            width: 80
          },
          {
            field: 'ZZFLD00002X',
            title: '含税单价',
            width: 100,
            slots: { default: 'ZZFLD00002X' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002Z',
            title: '价税合计',
            width: 100
          },
          {
            field: 'ZZFLD00002A',
            title: '折扣类型',
            width: 100,
            slots: { default: 'ZZFLD00002A' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002F',
            title: '单品折扣',
            width: 100
          },
          {
            field: 'ZZFLD00002G',
            title: '折后含税单价',
            width: 180
          },
          {
            field: 'ZZFLD00002I',
            title: '折扣额',
            width: 100,
            slots: { default: 'ZZFLD00002I' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD00002O',
            title: '已占用开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000035',
            title: '已占用开票件数',
            width: 180
          },
          {
            field: 'ZZFLD000007',
            title: '累计开票数量',
            width: 180
          },
          {
            field: 'ZZFLD000032',
            title: '累计开票件数',
            width: 180
          },
          {
            field: 'ZZFLD00002B',
            title: '是否关闭',
            width: 100,
            slots: { default: 'ZZFLD00002B' },
            params: { bgEdit: true }
          },
          {
            field: 'ZZFLD000008',
            title: '备注',
            width: 180,
            slots: { default: 'ZZFLD000008' },
            params: { bgEdit: true }
          }
        ],
        delData: [],
        orderData: [],
        fileDetailColumns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'FILENAME', title: '附件名称', slots: { default: 'FILENAME' }},
          { field: 'MIMETYPE', title: '附件类型' },
          { field: 'FILELENGTH', title: '大小', formatter: ({ cellValue }) => formatSapFileSize(cellValue) },
          { field: 'CREATED_DATE', title: '上传日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'CREATED_TIME', title: '上传时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        fileData: [],
        delFile: [],
        columnsFieldTypes: {
          default: '',
          ORDERED_PROD: 'selectProduct',
          ZZFLD000009: 'input',
          ZZFLD00002A: 'select',
          ZZFLD00002I: 'input',
          ZZFLD00002B: 'checkbox',
          ZZFLD000008: 'input'
        }
      },
      rewardList: [
        {
          field: 'REWARD_TYPE',
          title: '奖励类型编码',
          width: 100,
          slots: { default: 'REWARD_TYPE' },
          params: { bgEdit: true }
        },
        {
          field: 'REWARD_NUMBER',
          title: '奖励/计划编号',
          width: 120,
          slots: { default: 'REWARD_NUMBER' },
          editRender: {},
          params: { bgEdit: true }
        },
        {
          field: 'REWARD_NAME',
          title: '项目/计划类型',
          width: 180
        },
      ],
      gridOptionsCash: {
        columns: [
          {
            field: 'REWARD_NUMBER',
            title: '项目奖励编码',
            width: 120
          },
          {
            field: 'REWARD_ID',
            title: '项目类型编码',
            width: 120
          },
          {
            field: 'REWARD_NAME',
            title: '项目类型描述',
            width: 180
          },
          {
            field: 'CUSTOMER',
            title: '项目客户编码',
            width: 120
          },
          {
            field: 'CUSTOMER_NAME',
            title: '项目客户名称',
            width: 180
          },
          {
            field: 'START_DATE',
            title: '有效期起',
          },
          {
            field: 'END_DATE',
            title: '有效期止',
          },
          {
            field: 'QUOTA_RATIO',
            title: '额度比例(%)',
          },
          {
            field: 'AMOUNT',
            title: '项目金额（元）',
          },
          {
            field: 'REMAIN_AMOUNT',
            title: '剩余金额（元）',
          },
        ],
        data: [],
        delData: []
      },
      gridOptionsLinkBill: {
        columns: [
          {
            field: 'ZZFLD000011',
            title: '单据编号'
          },
          {
            field: 'ZZFLD000012_TEXT',
            title: '单据类型'
          },
          {
            field: 'ZZFLD000013',
            title: '创建日期',
            formatter: ({ cellValue }) => formatSapDate(cellValue)
          }
        ],
        data: []
      },
      gridOptionsHistory: {
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'ZZFLD00000U', title: '操作人' },
          { field: 'ZZFLD000031', title: '操作人姓名' },
          { field: 'ZZFLD00000V_TEXT', title: '状态' },
          { field: 'ZZFLD00000W', title: '变更日期', formatter: ({ cellValue }) => formatSapDate(cellValue) },
          { field: 'ZZFLD00000X', title: '变更时间', formatter: ({ cellValue }) => formatSapTime(cellValue) }
        ],
        data: []
      },
      gridOptionsNext: {
        columns: [
          { type: 'radio', title: '', field: 'radio', width: 50 },
          { field: 'order_type', title: '单据类型' },
          { field: 'text', title: '单据描述' }
        ],
        data: [{ order_type: 'ZM02', text: '配额酒材料计划' }, { order_type: 'ZPD2', text: '配额酒生产计划' }]
      }
    }
  },
  computed: {
    isDeve(){
      return process.env.NODE_ENV === 'development'
    },
    isEdit() {
      if (this.conditions.OBJECT_ID) {
        return !this.showEdit
      } else {
        return false
      }
    },
    ...mapGetters(['role', 'customerInfo'])
  },
  watch: {
    'conditions.CUSTOMER': {
      handler(nv) {
        this.productParams.CUSTOMER = nv
      }
    },
    'gridOptions.orderData': {
      handler(nv, ol) {
        nv.forEach((item, i) => {
          item.NUMBER_INT = (i + 1) * 10
        })
      },
      deep: true
    },
    'conditions.CUST_NAME': {
      handler(nv) {
        this.productParams.zzfld000001 = this.conditions.ZZFLD000001
      }
    }
  },
  created() {
    const pageQuery = this.$route.query
    if (pageQuery?.object_id) {
      this.pageMode = 'edit'
      this.initOrderInfoById(pageQuery.object_id, 1)
    } else {
      if (this.role.ROLE === 'WLY001') {
        const orgList = this.customerInfo.yxdy.filter(v => v.mc_short !== '其他销售类型')
        this.conditions.CUSTOMER = this.customerInfo.info.partner
        this.conditions.CUSTOMER_TYPE = this.customerInfo.info.zzfld000016
        this.conditions.CUST_NAME = this.customerInfo.info.name_org1
        this.conditions.ZZFLD000001 = orgList[0].zzfld00001h
        this.conditions.ZZFLD00003E = orgList[0].mc_short_jd
        this.conditions.ZZFLD000002 = this.customerInfo.info.region
        this.conditions.ZZFLD000002_TEXT = this.customerInfo.info.bezei
        this.conditions.ZZFLD000003 = this.customerInfo.info.city_code
        this.conditions.ZZFLD000003_TEXT = this.customerInfo.info.city_name
        this.conditions.ZZFLD000004 = this.customerInfo.info.sales_emp
        this.conditions.ZZFLD000004_DSCR = this.customerInfo.info.sales_emp_name
        this.productParams.CUSTOMER = this.customerInfo.info.partner
        this.$set(this.selectDataOptions, 'orgList', orgList)
      }
      this.conditions.ZZFLD00002D = this.role.USER_BP
      this.conditions.ZZFLD00002D_DSCR = this.role.login_user
      this.conditions.POSTING_DATE = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      this.tableEvent('add')
    }
    if(this.role.ROLE == 'WLY002' || this.role.ROLE == 'WLYALL'){
      this.gridOptions.orderDetailcolumns.splice(2, 0, ...this.rewardList);
    }
    // 折扣类型
    this.getSelectDictDataOrigin('A0037')
    // 非配额酒销售订单状态
    this.getSelectDictDataOrigin('A0041')
    // 销售订单类型
    this.getSelectDictDataOrigin('A0043')
    // 客户类型
    this.getSelectDictDataOrigin('A0009')
    // 奖励政策
    this.getSelectDictDataOrigin('A0077')
  },
  methods: {
    changeType(e,idx){
      if(e == 'V001'){
        this.gridOptions.orderData[idx].ZZFLD00002A = 'V003'
      }else if(e == 'V002'){
        this.gridOptions.orderData[idx].ZZFLD00002A = 'V002'
      }else{
        this.gridOptions.orderData[idx].REWARD_NUMBER = ''
        this.gridOptions.orderData[idx].REWARD_ID = ''
        this.gridOptions.orderData[idx].REWARD_NAME = ''
        this.gridOptions.orderData[idx].ZZFLD00002A = ''
      }
    },
    cellClassName({ column }) {
      if (column.params?.bgEdit) {
        return 'cell--bg--edit'
      } else {
        return 'cell--bg--default'
      }
    },
    // 根据id查询订单信息
    async initOrderInfoById(OBJECT_ID, type = 0) {
      this.loading = true
      try {
        const res = await getOrderDetail({ OBJECT_ID })
        if (res?.MSGTYPE === 'S') {
          const { DATA } = res
          Object.assign(this.conditions, DATA.INFO)
          this.conditions.cancel = res.CANCEL
          this.conditions.change = res.CHANGE
          this.conditions.follow_up = res.FOLLOW_UP
          this.gridOptions.orderData = DATA.ITEM
          this.gridOptions.fileData = DATA.ATTACHMENT
          this.gridOptionsHistory.data = DATA.HISTORY || []
          this.gridOptionsLinkBill.data = DATA.CONNECT || []
          this.gridOptionsCash.data = DATA.CASH || []

          type && this.initCustome()
        }
      } catch (e) {
        //
      }
      this.loading = false
    },
    async createNext() {
      const data = this.$refs.next.getRadioRecord()
      if (data) {
        const params = {
          user_bp: this.role.USER_BP,
          head: this.conditions,
          plan_type: data.order_type,
          item: this.gridOptions.data,
          mode: 'OTHER'
        }
        const res = await apiCreateFollow(params)
        this.$router.push({
          name: data.order_type === 'ZM02' ? '40.01 材料计划单创建' : '50.01 生产计划单创建',
          params: res
        })
      } else {
        this.$message.warning('请选择有效数据！')
      }
    },
    async orderModify() {
      const res = await this.orderlock('ADD')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = true
    },
    async orderDisplay() {
      const res = await this.orderlock('DELETE')
      if (!res) return
      await this.initOrderInfoById(this.conditions.OBJECT_ID)
      this.showEdit = false
    },
    // 订单解锁
    async orderlock(mode) {
      this.errorList = []
      const params = {
        type: this.conditions.PROCESS_TYPE,
        number: this.conditions.OBJECT_ID,
        status: mode === 'ADD' ? 1 : 2
      }
      if (mode === 'UNLOCK') {
        await this.$confirm('解锁前请确认当前没有其他人修改此订单！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      }
      const { data } = await apiOrderLock(params)
      if (data.status && params.status === 1) {
        this.errorList = [data.message]
        return false
      }
      return true
    },
    async confirmMode(type) {
      const types = {
        SUBMIT: '提交',
        CANCEL: '取消',
        REJECT: '审核拒绝',
        APPROVE: '审核通过'
      }
      if (!types[type]) {
        return Promise.resolve()
      }
      await this.$confirm(`是否确认${types[type]}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 保存 提交 确认  新建 E0001,已保存待提交 E0002,已提交待审核 E0003, 审核通过 E0004,审核拒绝 E0005,已取消 E0006
    changeStatus(status) {
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          // await this.confirmMode(status)
          // apiNoQuotaSave
          const params = {
            user_bp: this.role.USER_BP,
            MODE: status,
            info: this.conditions,
            item: this.gridOptions.orderData.concat(this.gridOptions.delData),
            attachment: this.gridOptions.fileData.concat(this.gridOptions.delFile)
          }
          this.loading = true
          this.errorList = []
          const result = await apiNoQuotaSave(params)
          if (result?.MSGTYPE === 'S') {
            this.$message.success(result.MESSAGE)
            this.gridOptions.delData = []
            this.gridOptions.delFile = []
            this.conditions.OBJECT_ID = result.DATA.INFO.OBJECT_ID
            this.orderDisplay()
          } else {
            this.errorList.push(result.MESSAGE)
            this.loading = false
            return
          }

          const { DATA } = result
          Object.assign(this.conditions, DATA.INFO)
          this.conditions.cancel = DATA.CANCEL
          this.conditions.change = DATA.CHANGE
          this.conditions.follow_up = DATA.FOLLOW_UP
          this.gridOptions.orderData = DATA.ITEM
          this.gridOptions.fileData = DATA.ATTACHMENT
          this.gridOptionsHistory.data = DATA.HISTORY || []
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    // 初始化数据字典
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        partner: this.conditions.CUSTOMER,
        user_bp: this.role.USER_BP
      }
      const { data } = await apiSapSingleClientInfo(params)
      const orgList = data.yxdy.filter(v => v.mc_short !== '其他销售类型')
      this.$set(this.selectDataOptions, 'orgList', orgList)
    },
    // 选择营销单元
    saleCenterChange(e) {
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.ZZFLD000001Name = checkedData.mc_short
      this.conditions.ZZFLD00003E = checkedData.mc_short_jd
      this.productParams.zzfld000001 = e
      this.errorList = []
      this.gridOptions.orderData = []
      this.gridOptions.delData = []
      this.gridOptions.fileData = []
      this.gridOptions.delFile = []
      this.gridOptionsLinkBill.data = []
      this.gridOptionsHistory.data = []
      this.tableEvent('add')
    },
    tableEvent(btn) {
      const orderDetailsEmpty = {}
      this.gridOptions.orderDetailcolumns.forEach(v => {
        !v.type && (orderDetailsEmpty[v.field] = '')
      })
      switch (btn) {
        case 'add':
          // orderDetailsEmpty.NUMBER_INT = (this.gridOptions.orderData.length + 1) * 10
          this.gridOptions.orderData.push(orderDetailsEmpty)
          break
        case 'del':
          this.delDetail()
          break
      }
    },
    async delDetail() {
      const checkedList = this.$refs.orderDetail.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效数据！')

      checkedList.forEach(item => {
        item.MODE = 'D'
        const index = this.gridOptions.orderData.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.orderData.splice(index, 1)
      })
      if (this.conditions.OBJECT_ID) {
        this.gridOptions.delData = this.gridOptions.delData.concat(checkedList.filter(v => v.GUID))
      }
    },
    // 删除合同附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()
      if (!checkedList.length) return this.$message.warning('请选择有效数据！')
      checkedList.forEach(file => {
        file.delete_flag = 'X'
        const index = this.gridOptions.fileData.findIndex(v => v._X_ID === file._X_ID)
        this.gridOptions.fileData.splice(index, 1)
      })
      if (this.conditions.OBJECT_ID) {
        this.gridOptions.delFile = this.gridOptions.delFile.concat(checkedList.filter(v => v.GUID))
      }
    },
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')

        const dateTime = new Date().getTime()

        const fileData = {
          FILENAME: file.name,
          MIMETYPE: file.raw.type,
          DOC_TYPE: file.raw.type,
          XCONTENT: strArr,
          FILELENGTH: file.size,
          ZZFLD00002D: _this.role.USER_BP,
          ZZFLD00002D_DSCR: _this.role.login_user,
          CREATED_DATE: _this.$utilsCommon.parseTime(dateTime, '{y}{m}{d}'),
          CREATED_TIME: _this.$utilsCommon.parseTime(dateTime, '{h}{i}{s}')
        }

        _this.gridOptions.fileData.unshift(fileData)
      }
    },
    // 下载文件
    downLoadFile(row) {
      sapDownloadFile(row.XCONTENT, row.FILENAME)
    },
    async checkClientAdd(mode) {
      if (mode === 'address' && !this.conditions.ZZFLD00008T) {
        return this.$message.warning('请选择收货方')
      }
      // 初始化新增数据
      const params = {
        mode: mode === 'client' ? '' : 'X',
        head: this.conditions
      }
      params.role = this.role.ROLE
      const result = await apiInitClientAdd(params)
      if (result?.MSGTYPE !== 'S') {
        return this.$message.warning(result.MESSAGE)
      }
      const { DATA } = result
      this.initClientAddData = { head: DATA.HEAD, info: DATA.INFO }
      this.mode = mode
      this.dialogTitle = mode === 'client' ? '新增客户' : '新增地址'
      this.showDialog = true
    },
    // 打开窗口
    openSelectDialog(e, type, row, mode) {
      e.target.blur()
      this.currentDetail = row
      this.showDialogType = type
      if (type === 'clientAdd') {
        return this.checkClientAdd(mode)
      }
      this.dialogTitle = {
        product: '产品选择',
        client: '客户选择',
        receive: '收货方选择',
        reward: '剩余现金奖励选择',
      }[type]
      this.showDialog = true
    },
    async updateSaleItem() {
      const params = {
        info: this.conditions,
        item: this.gridOptions.orderData
      }
      this.errorList = []
      const result = await apiNoQuotaUpdateSaleItem(params)
      // if (result?.MSGTYPE === 'S') {
      if (result?.MSGTYPE === 'E') {
        this.errorList.push(result.MESSAGE)
      }

      const { DATA } = result
      this.gridOptionsCash.data = DATA.CASH_REWARD
      Object.assign(this.conditions, DATA.INFO)
      this.gridOptions.orderData = DATA.ITEM
    },
    productSelect(res) {
      this.currentDetail.ORDERED_PROD = res.PRODUCT_ID
      this.currentDetail.UNIT = res.MSEHT
      this.currentDetail.DESCRIPTION = res.SHORT_TEXT
      this.currentDetail.ZZFLD00002S = res.NORMS

      this.updateSaleItem()
    },
    clientSelect(res) {
      // if (res.partner === this.conditions.CUSTOMER) {
      //   return
      // }
      const orgList = res.orgList.filter(v => v.mc_short !== '其他销售类型')
      this.conditions.CUSTOMER = res.partner
      this.conditions.CUSTOMER_TYPE = res.zzfld000016
      this.conditions.CUST_NAME = res.name_org1
      this.conditions.ZZFLD000001 = orgList[0].zzfld00001h
      this.conditions.ZZFLD00003E = orgList[0].mc_short_jd
      this.conditions.ZZFLD000002 = res.region
      this.conditions.ZZFLD000002_TEXT = res.bezei
      this.conditions.ZZFLD000003 = res.city_code
      this.conditions.ZZFLD000003_TEXT = res.city_name
      this.conditions.ZZFLD000004 = res.sales_emp
      this.conditions.ZZFLD000004_DSCR = res.sales_emp_name
      this.productParams.CUSTOMER = res.partner
      this.$set(this.selectDataOptions, 'orgList', orgList)
      //  清空运达方
      this.conditions.ZZFLD00008T_DSCR = ''
      this.conditions.ZZFLD00008T = ''
      this.conditions.ZZFLD00002L = ''
      this.conditions.ZZFLD00002M = ''
      this.conditions.ZZFLD00002N = ''
      this.gridOptions.orderData = []
      this.gridOptions.delData = []
      this.gridOptions.fileData = []
      this.gridOptions.delFile = []
      this.gridOptionsLinkBill.data = []
      this.gridOptionsHistory.data = []
      this.tableEvent('add')
    },
    receiveSelect(res) {
      this.conditions.ZZFLD00008T_DSCR = res.NAME_ORG1
      this.conditions.ZZFLD00008T = res.PARTNER
      this.conditions.ZZFLD00002L = res.C_O_NAME
      this.conditions.ZZFLD00002M = res.TEL_NUMBER
      this.conditions.ZZFLD00002N = res.STREET
    },
    // 添加客户地址
    async addClientInfo(res) {
      const result = await apiClientAdd(res)
      if (result.MSGTYPE === 'S') {
        this.$message.success(result.MESSAGE)
      } else {
        return this.$message.warning(result.MESSAGE)
      }

      this.conditions.ZZFLD00008T_DSCR = result.DATA.NAME_LAST
      this.conditions.ZZFLD00008T = result.DATA.PARTNER
      this.conditions.ZZFLD00002L = result.DATA.C_O_NAME
      this.conditions.ZZFLD00002M = result.DATA.TEL_NUMBER
      this.conditions.ZZFLD00002N = result.DATA.STREET
      this.conditions.MARKTSPT = result.DATA.MARKTSPT

      this.showDialog = false
    },
    selectReward(res){
      this.currentDetail.REWARD_NUMBER = res.reward_number
      this.currentDetail.REWARD_ID = res.reward_id
      this.currentDetail.REWARD_NAME = res.reward_name
      this.updateSaleItem()
    },
    // 弹窗内的方法这边来处理，方便数据回调在本页面处理
    submitHandle() {
      this.$refs.dialogEdit.submitForm().then(res => {
        switch (this.showDialogType) {
          case 'product':
            this.productSelect(res)
            break
          case 'client':
            this.clientSelect(res)
            break
          case 'receive':
            this.receiveSelect(res)
            break
          case 'clientAdd':
            this.addClientInfo(res)
            break
          case 'reward':
            this.selectReward(res)
            break
        }
        if (this.showDialogType !== 'clientAdd') {
          this.showDialog = false
        }
      })
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }

      if (!data) return

      this.currentDetail = row

      switch (type) {
        case 'customer':
          this.clientSelect(data)
          break
        case 'salesProduct':
          this.productSelect(data)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-form {
  text-align: left;
  .blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/order-manage/noQuotaOrderEdit.vue